import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import CKEditor from 'ckeditor4-react';
import { CKEDITOR_URL } from '../../../../constants';

CKEditor.editorUrl = CKEDITOR_URL;

const editorConfig = {
  allowedContent: true,
  autoGrow_minHeight: 200,
  extraAllowedContent:
    'iframe[align,frameborder,height,id,longdesc,name,sandbox,scrolling,src,tabindex,title,width]',
  extraPlugins: 'autogrow',
  removeDialogTabs: 'image:advanced;link:advanced;table:advanced',
  removePlugins:
    'clipboard,image2,iframe,liststyle,uploadfile,pastefromgdocs,pastefromlibreoffice,pastefromword,pastetext,pastetools,placeholder,uploadimage,elementspath,toolbar,resize,widget,uploadwidget',

  resize_enabled: false,
  startupShowBorders: false,
};

const EmailTemplatePreview = ({ content, name, width = '528px' }) => (
  <div className={classnames('email-template-preview', name)}>
    <CKEditor
      config={editorConfig}
      style={{ width, border: 'none' }}
      data={content}
      name={name}
      readOnly
    />
  </div>
);

EmailTemplatePreview.propTypes = {
  content: PropTypes.string,
  name: PropTypes.string,
  width: PropTypes.string,
};

export default EmailTemplatePreview;
